import React, { FC } from 'react';
import { Flex, FlexProps, Spinner, Text } from '@chakra-ui/react';

interface LoadingProps extends FlexProps {
  text?: string;
}

const Loading: FC<LoadingProps> = ({ text, ...props }) => (
  <Flex justifyContent='center' alignItems='center' bg='bg-default' h='100vh' {...props}>
    <Flex alignItems='center'>
      <Text colorScheme='brand' mr='3'>
        {text}
      </Text>
      <Spinner size='xl' colorPalette='brand' />
    </Flex>
  </Flex>
);

export default Loading;
